var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDashboardWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 16.667,
    viewBox: "0 0 25 16.667",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -85.333)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 85.333)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M241.094,213.469,235,218.83l-.023.022a1.042,1.042,0,0,0,.735,1.779,1.056,1.056,0,0,0,.76-.33l5.361-6.1a.521.521,0,0,0-.735-.735Z",
    transform: "translate(-223.209 -207.089)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12.5,85.333a12.5,12.5,0,0,0-11.906,16.3.521.521,0,0,0,.5.362H23.91a.521.521,0,0,0,.5-.362A12.5,12.5,0,0,0,12.5,85.333Zm9.9,13.021h1.526a11.408,11.408,0,0,1-.4,2.6H1.477a11.408,11.408,0,0,1-.4-2.6H2.6a.521.521,0,0,0,0-1.042H1.068a11.369,11.369,0,0,1,1.267-4.746l1.334.771a.521.521,0,0,0,.521-.9l-1.331-.769a11.534,11.534,0,0,1,3.474-3.474L7.1,89.524A.52.52,0,1,0,8,89l-.77-1.335A11.369,11.369,0,0,1,11.979,86.4v1.536a.521.521,0,1,0,1.042,0V86.4a11.369,11.369,0,0,1,4.747,1.267L17,89a.52.52,0,1,0,.9.521l.769-1.332a11.534,11.534,0,0,1,3.474,3.474l-1.331.769a.521.521,0,0,0,.521.9l1.334-.771a11.369,11.369,0,0,1,1.267,4.746H22.4a.521.521,0,1,0,0,1.042Z",
    transform: "translate(0 -85.333)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDashboardWhite);
export default __webpack_public_path__ + "static/media/iconDashboardWhite.5697c4386ae8e5ed6d2f7907f6c210e4.svg";
export { ForwardRef as ReactComponent };